<script setup lang="ts">
import type { AvatarImageProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { AvatarImage, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<AvatarImageProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');
const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <AvatarImage
        data-slot="avatar-image"
        v-bind="forwardedProps"
        :class="cn('aspect-square h-full w-full', props.class)"
    />
</template>
